import axios, { AxiosRequestConfig } from 'axios';

interface RequestConfig extends AxiosRequestConfig {
    start_time: number;
}

const service = axios.create({
    baseURL: '/',
    timeout: 10000,
});

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

service.interceptors.request.use(config => {
    const requestConfig: Partial<RequestConfig> = config;
    requestConfig.start_time = new Date().getTime();

    return requestConfig;
});

service.defaults.xsrfHeaderName = 'x-csrf-token';
service.defaults.xsrfCookieName = 'csrfToken';

service.interceptors.response.use(
    response => {
        const { data } = response;
        return data;
    },
    error => {
        return Promise.reject(error);
    }
);

export default service;
